import React, { useState, Suspense } from 'react';
import PropTypes from 'prop-types';
import EvandStatistics from 'components/Campaign/statistics/EvandStatistics';
import ServiceProviderStatistics from './ServiceProviderStatistics';
import Loading from 'components/Loading';
import { api } from 'app';
import Button from 'packages/ui/Button';
import Spinner from 'packages/ui/Spinner';
import PersianDate from 'packages/ui/PersianDate';
import styled from 'styled-components';
import Report from 'components/Campaign/statistics/Report';

function Statistics({ campaignId }) {
  const [loaded, setLoaded] = useState(false);
  const [requesting, setRequesting] = useState(false);
  const [campaignStatistics, setCampaignStatistics] = useState();
  const [campaignChannel, setCampaignChannel] = useState();
  const [errorMsg, setErrorMsg] = useState();

  const Width = styled.div`
    width: ${props => (props.width ? props.width : 100)}%;
    display: ${props => (props.display ? props.display : 'block')};
  `;

  const getCampaignStatistics = async () => {
    setRequesting(true);

    api.get(`/advertising-campaigns/${campaignId}/statistics`).then(res => {
      setCampaignStatistics(res.body.data);
      if (res.body.message) {
        setErrorMsg(res.body.message);
      }

      api.get(`/advertising-campaigns/${campaignId}`).then(res => {
        setCampaignChannel(res.body.data.channel);
        setLoaded(true);
        setRequesting(false);
      });
    });
  };

  return (
    <Width display={'flex'}>
      <Width width={50}>
        {!loaded ? (
          <div>
            {requesting ? (
              <>
                <p>در حال دریافت آمار...</p>
                <Spinner sizePx={20} />
              </>
            ) : (
              <Button mood="primary" onClick={getCampaignStatistics}>
                دریافت آمار لحظه‌ای
              </Button>
            )}
          </div>
        ) : (
          <>
            <p>
              تاریخ به روز رسانی:{' '}
              <strong>
                <PersianDate value={new Date()} />
              </strong>
            </p>

            <EvandStatistics key="evand" data={campaignStatistics.evand} />

            {campaignStatistics.service_provider.length === 0 ? null : (
              <ServiceProviderStatistics
                key="serviceProvider"
                campaignChannel={campaignChannel}
                data={campaignStatistics.service_provider}
              />
            )}

            {errorMsg && <p>{errorMsg}</p>}
          </>
        )}
      </Width>
      <Width width={50}>
        <Report campaignId={campaignId} />
      </Width>
    </Width>
  );
}

function CampaignStatistics(props) {
  return (
    <Suspense fallback={<Loading />}>
      <Statistics {...props} />
    </Suspense>
  );
}

CampaignStatistics.propTypes = {
  campaignId: PropTypes.number.isRequired
};

export default CampaignStatistics;
